import { Routes } from '@angular/router';
import { servicesResolver } from './features/shared/services.resolver';
import { NotFoundComponent } from './features/shared/not-found/not-found.component';
import { locationResolver } from './features/shared/location.resolver';
import { customSubdomainGuard, subdomainCatchAllGuard } from './guards/custom-subdomain.guard';
import { manageAppointmentTokenRedirectGuard } from './guards/manage-appointment-token-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: NotFoundComponent,
    canActivate: [customSubdomainGuard],
  },
  {
    path: 'page-not-found',
    data: { showHeader: true, hideSider: true, showBackButton: false },
    component: NotFoundComponent,
  },
  {
    path: 'm/:appointmentToken',
    canActivate: [manageAppointmentTokenRedirectGuard],
    component: NotFoundComponent,
    data: { showHeader: true, hideSider: true, showBackButton: false },
  },
  {
    // Subdomain short URLs (e.g. /services/...), redirects to /:uuid/...
    path: '**',
    canMatch: [subdomainCatchAllGuard],
    component: NotFoundComponent,
  },
  {
    data: { routeTag: 'location' },
    path: ':locationUuid',
    resolve: { location: locationResolver },
    children: [
      {
        path: 'services',
        resolve: { servicesData: servicesResolver },
        loadChildren: () => import('./features/appointment/appointment.routes').then((m) => m.APPOINTMENT_ROUTES),
      },
      {
        path: 'legal',
        resolve: {},
        loadChildren: () => import('./features/legal/legal.routes').then((m) => m.LEGAL_ROUTES),
      },
      {
        path: 'toolkit',
        loadChildren: () => import('./features/toolkit/toolkit.routes').then((m) => m.TOOLKIT_ROUTES),
      },
    ],
  },
  { path: '**', data: { showHeader: true, hideSider: true, showBackButton: false }, component: NotFoundComponent },
];
